import type { RefObject } from 'react';

import { SelectionArea, type SelectionAreaProps } from './SelectionArea.js';
import type { _SelectionRef } from './types.js';
import { usePointerAndScrollResponsiveChartBounds } from '../../hooks/usePointerAndScrollResponsiveChartBounds.js';

export const DynamicSelectionArea = ({
  selection,
  chartRef,
  variant,
  focusable,
  interactable,
  onKeyDown,
  onSelectionChange,
  isBottomLabelRotated,
  isTopLabelRotated,
  selectionAreaRef,
  bottomFormatter,
  topFormatter,
  hasMagnifiers,
}: Omit<SelectionAreaProps, 'bounds'> & {
  hasMagnifiers: boolean;
  selectionAreaRef: RefObject<_SelectionRef | null> | undefined;
  chartRef: RefObject<HTMLDivElement | null>;
}) => {
  const chartBounds = usePointerAndScrollResponsiveChartBounds(
    chartRef,
    hasMagnifiers,
  )();
  if (!chartBounds) {
    return null;
  }

  return (
    <SelectionArea
      selection={selection}
      bounds={chartBounds}
      variant={variant}
      focusable={focusable}
      interactable={interactable}
      bottomFormatter={bottomFormatter}
      topFormatter={topFormatter}
      onKeyDown={onKeyDown}
      onSelectionChange={onSelectionChange}
      isBottomLabelRotated={isBottomLabelRotated}
      isTopLabelRotated={isTopLabelRotated}
      ref={selectionAreaRef}
    />
  );
};
